export {}

require('./indes.css')
